<template>
  <div class="search-filter-container">
    <div class="filter-row">
      <div class="filter-item">
        <label>회사명</label>
        <a-input
          v-model:value="localKeyword"
          placeholder="회사명을 입력하세요"
          allow-clear
          @pressEnter="handleSearch"
          style="width: 200px"
        />
      </div>
      <div class="filter-item">
        <label>상태</label>
        <a-select
          v-model:value="localStatus"
          :options="statusOptions"
          placeholder="전체"
          style="width: 140px"
          allow-clear
        />
      </div>
      <div class="filter-actions">
        <a-button type="primary" class="yellow-button" @click="handleSearch">
          검색
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { COUNSELOR_STATUS_FILTER_OPTIONS } from '../constants';

export default {
  name: 'CounselorSearchFilter',
  props: {
    keyword: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  emits: ['update:keyword', 'update:status', 'search'],
  setup(props, { emit }) {
    const statusOptions = COUNSELOR_STATUS_FILTER_OPTIONS;

    const localKeyword = computed({
      get: () => props.keyword,
      set: (value) => emit('update:keyword', value),
    });

    const localStatus = computed({
      get: () => props.status,
      set: (value) => emit('update:status', value),
    });

    const handleSearch = () => {
      emit('search');
    };

    return {
      statusOptions,
      localKeyword,
      localStatus,
      handleSearch,
    };
  },
};
</script>

<style scoped lang="scss">
.search-filter-container {
  padding: 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}

.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.yellow-button {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;

  &:hover {
    background-color: #e6b82d !important;
    border-color: #e6b82d !important;
  }
}
</style>
